// removed by extract-text-webpack-plugin
module.exports = {"pagechildren":"_30Rg80KS5mFggCQyEb7lA-","childa":"kaeMqj4tYmUB8uHSU2Jdq","status":"pHZT2I7m_yrWkBrNJ8ZaB","evaluate":"_2TiK2TtVXHChX4PpwZp1Cx","childb":"Z0X5AJg9yv6V0Zb3PnY5","pagelienew":"eUp6H1NWtUavHY7nP4tP_","lienewtop":"_1OORH7TOEhWbaNjND0qyfa","newtoptxt":"_1czNFe-bVQPKYzCyLgdqDF"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/OrderListComponent/OrderListComponent.scss
 ** module id = 1004
 ** module chunks = 0
 **/